import { Bot, FileText, X } from "lucide-react";

import { Button } from "@workanywhere/ui";
import { Card, CardContent } from "@workanywhere/ui";
import { formatDateTime, formatEventTitle, getItemType, getThreadId } from "../../agent-updates";
import type { AgentUpdateRecord } from "../../../../../shared/agent";
import { SummaryLine } from "./ui-bits";

export function EventInspector({ record, onClose }: { record: AgentUpdateRecord | null; onClose?: () => void }) {
  if (!record) {
    return (
      <div className="flex h-full min-h-[520px] items-center justify-center p-6 text-center">
        <div>
          <Bot className="mx-auto mb-3 size-8 text-muted-foreground" />
          <h2 className="text-sm font-semibold">No event selected</h2>
          <p className="mt-1 text-sm text-muted-foreground">Incoming events will appear here.</p>
        </div>
      </div>
    );
  }

  return (
    <aside className="min-h-[520px] bg-card/40">
      <div className="flex h-full min-h-[520px] flex-col">
        <div className="flex items-start justify-between gap-3 border-b px-4 py-3">
          <div className="min-w-0">
            <h2 className="text-sm font-semibold">Event Inspector</h2>
            <p className="mt-1 truncate text-xs text-muted-foreground">{record.id}</p>
          </div>
          {onClose ? (
            <Button type="button" variant="ghost" size="icon-sm" aria-label="Close event inspector" onClick={onClose}>
              <X className="size-4" />
            </Button>
          ) : null}
        </div>
        <div className="min-h-0 flex-1 overflow-auto p-4">
          <div className="flex flex-col gap-4">
            <Card className="rounded-lg py-4 shadow-none">
              <CardContent className="flex flex-col gap-3 px-4">
                <SummaryLine label="Event" value={formatEventTitle(record)} />
                <SummaryLine label="Type" value={record.event.type} />
                <SummaryLine label="Sequence" value={record.sequence.toString()} />
                <SummaryLine label="Received" value={formatDateTime(record.receivedAt)} />
                <SummaryLine label="Thread" value={getThreadId(record) ?? "none"} />
                <SummaryLine label="Item" value={getItemType(record) ?? "none"} />
              </CardContent>
            </Card>
            <div>
              <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
                <FileText className="size-4" />
                Raw JSON
              </div>
              <pre className="max-h-[460px] overflow-auto rounded-lg border bg-muted/40 p-3 text-xs leading-relaxed">
                {JSON.stringify(record.event, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
